import * as React from 'react'

import { Box } from '~ui/components/layout/Box'

type TProps = RequiredChildren & Omit<PropsOf<typeof Box>, 'as'>

/**
 * fieldset component used to group form’s inputs into segments
 * useful for sematic and layout purposes
 */
export const InputGroup: React.FC<TProps> = (props) => {
  return <Box display={`grid`} rowGap={`medium`} {...props} as={`fieldset`} />
}
